import { useEffect } from "react";
import { SITE } from "../lib/constants";

/**
 * Sets document title, meta description, OG tags and optional structured data.
 */
export default function SEO({
  title,
  description,
  keywords,
  canonical,
  structuredData,
  image,
}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description || SITE.shortDescription);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description || SITE.shortDescription, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", SITE.name, "property");
    if (image) setMeta("og:image", image, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description || SITE.shortDescription);

    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    // Structured data
    const id = "ld-json-page";
    let oldScript = document.getElementById(id);
    if (oldScript) oldScript.remove();
    if (structuredData) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }

    return () => {
      const ld = document.getElementById(id);
      if (ld) ld.remove();
    };
  }, [title, description, keywords, canonical, image, structuredData]);

  return null;
}
